function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#969EA2",
  fillRule: "nonzero",
  d: "M4 0h16a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4zm1.6 14.6h12.8v1.8H5.6v-1.8zM5 13a1 1 0 00-1 1v3a1 1 0 001 1h14a1 1 0 001-1v-3a1 1 0 00-1-1H5zm.6-5.4h12.8v1.8H5.6V7.6zM5 6a1 1 0 00-1 1v3a1 1 0 001 1h14a1 1 0 001-1V7a1 1 0 00-1-1H5z"
})));